import React, { useCallback, useState, memo } from 'react';

import { InputBox, SelectBox, DateInput } from 'common/FormField/formField';
import Button from 'common/Button/Button';
import { DemoFormWrap } from './DropQueryStyles';
import Loader from 'common/Loader/Loader';
import { APPLICATION_CONSTANTS } from 'AppConstants';

const DropQueryForm = ({ formFields, handleSubmit, status }) => {
	const [isDisabled, setDisabled] = useState(true);

	const onChangeInput = useCallback(() => {
		let error = false;
		const fieldLen = formFields.length;
		for (let i = 0; i < fieldLen; i++) {
			error = !formFields[i].value && formFields[i].isMandatory || formFields[i].error;
			if (error) {
				break;
			}
		}
		setDisabled(error);
	}, [isDisabled]);

	const showLoader = status === APPLICATION_CONSTANTS.PENDING;
	const disableClass = showLoader ? 'disabledwithLoader' : '';
	const btnText = showLoader ? (<Loader margin='0' color='#fff' size='9' />) : 'REQUEST NOW';

	return (
		<DemoFormWrap>
			{formFields.map((field) => (
				<React.Fragment key={field.name}>
					{field.type === 'select' ? <SelectBox onChange={onChangeInput} field={field} /> :
						field.type === 'date' ? <DateInput handleValChange={onChangeInput} field={field} /> :
						<InputBox handleChange={onChangeInput} key={field.name} field={field} />}
				</React.Fragment>
			))}
			<Button
				btnTxt={btnText}
				disableClass={disableClass}
				btnType='Flat'
				btnName='Primary'
				btnShadow
				btnWidth='100%'
				height='44px'
				handleClick={handleSubmit}
				disabled={isDisabled || showLoader}
			/>
		</DemoFormWrap>
	);
};

export default memo(DropQueryForm);
